<script setup>
import { router } from '@inertiajs/vue3';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import DialogModal from '@js/components/dialogs/DialogModal.vue';
import ComboboxField from '@js/components/fields/ComboboxField.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { tenants } = defineProps({
    tenants: {
        type: Array,
        required: true,
    },
});

const { route } = useRoute();

const tenant = ref(tenants[0] ?? null);

const isOpen = ref(false);

function action() {
    if (!tenant.value) {
        return;
    }

    router.visit(
        route('front.projectManagement.customer.websiteVariant', {
            tenant: tenant.value.id,
        }),
    );
}
</script>

<template>
    <DialogModal v-model="isOpen" size="small">
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #title> Créer un site </template>

        <template #content>
            <div class="min-h-96">
                <FormContent>
                    <ComboboxField
                        v-model="tenant"
                        :options="tenants"
                        label="Nom du client"
                        field-name="tenant"
                        field-id="tenant"
                        filteredOptionKey="name"
                    >
                        <template #optionContent="{ option }">
                            {{ option.name }}
                        </template>
                    </ComboboxField>
                </FormContent>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-end gap-2">
                <ActionButton
                    type="transparent"
                    :callback="() => (isOpen = false)"
                >
                    Annuler
                </ActionButton>

                <ActionButton :callback="action"> Créer </ActionButton>
            </div>
        </template>
    </DialogModal>
</template>
